import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateCalendarStyleOptions,
  updateChartMargins,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import BasicMargins from './ChartMarginComponents/BasicMargin';
import RadiusMargins from './ChartMarginComponents/RadiusMargins';
import FunnelMargins from './ChartMarginComponents/FunnelMargins';
import CalendarMargins from './ChartMarginComponents/CalendarMargins';
import HorizontalChartsMargins from './ChartMarginComponents/HorizontalChartsMargins';
import { RootState } from '../../../redux';
interface ChartMarginProps {
  iconColor?: string;
}

const ChartMargin: React.FC<ChartMarginProps> = ({ iconColor }) => {
  const dispatch = useDispatch();

  const { chartControls, chartProperties, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    chartProperties: state.chartProperties,
    tabTileProps: state.tabTileProps,
  }));

  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const chartType = chartProperties.properties[propKey].chartType;
  const margin = chartControls.properties[propKey].chartMargin;
  const calendarStyle = chartControls.properties[propKey].calendarStyleOptions;

  const handleMarginChange = (option: string, value: number) => {
    dispatch(updateChartMargins(propKey, option, value));
  };

  const handleCalendarStyleChange = (option: string, value: number) => {
    dispatch(updateCalendarStyleOptions(propKey, option, value));
  };

  const renderMarginControls = () => {
    switch (chartType) {
      case 'pie':
        return (
          <RadiusMargins
            radius={margin.radius}
            onChange={handleMarginChange}
            chartType={chartType}
            iconColor={iconColor}
          />
        );

      case 'gauge':
        return (
          <RadiusMargins
            gaugeRadius={margin.gaugeRadius}
            onChange={handleMarginChange}
            chartType={chartType}
            iconColor={iconColor}
          />
        );

      case 'donut':
      case 'rose':
        return (
          <RadiusMargins
            innerRadius={margin.innerRadius}
            outerRadius={margin.outerRadius}
            onChange={handleMarginChange}
            chartType={chartType}
            iconColor={iconColor}
          />
        );

      case 'funnel':
        return (
          <FunnelMargins
            top={margin.top}
            bottom={margin.bottom}
            funnelLeft={margin.funnelLeft}
            funnelRight={margin.funnelRight}
            onChange={handleMarginChange}
            iconColor={iconColor}
          />
        );

      case 'calendar':
        return (
          <CalendarMargins
            calendarHeight={calendarStyle.calendarHeight}
            calendarGap={calendarStyle.calendarGap}
            right={margin.right}
            left={margin.left}
            onMarginChange={handleMarginChange}
            onCalendarStyleChange={handleCalendarStyleChange}
            iconColor={iconColor}
          />
        );

      case 'horizontalBar':
      case 'horizontalStacked':
        return (
          <HorizontalChartsMargins
            top={margin.top}
            right={margin.right}
            bottom={margin.bottom}
            horizontalLeft={margin.horizontalLeft ?? margin.left}
            onChange={handleMarginChange}
            iconColor={iconColor}
          />
        );

      case 'multibar':
      case 'stackedBar':
      case 'stackedArea':
      case 'line':
      case 'area':
      case 'scatterPlot':
      case 'heatmap':
      case 'crosstab':
      case 'boxPlot':
      case 'treeMap':
      case 'sankey':
      case 'simplecard':
      case 'waterfall':
        return (
          <BasicMargins
            top={margin.top}
            right={margin.right}
            bottom={margin.bottom}
            left={margin.left}
            onChange={handleMarginChange}
            iconColor={iconColor}
          />
        );

      default:
        return null;
    }
  };

  return <div className="optionsInfo">{renderMarginControls()}</div>;
};

export default ChartMargin;
